module.exports = __webpack_public_path__ + "e9c5c588e39d0765d30bcd6594734102.ttf";